import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { GetEventStatsDTO } from '../../dto/events'
import { store } from '../../store'

export const getEventStats = async () => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/events/stats`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_STATS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_EVENT_STATS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_EVENT_STATS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetEventStatsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_EVENT_STATS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_EVENT_STATS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'GET_EVENT_STATS_OK', stats: body } )

}
